import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config';
import App from './App';
import * as serviceWorker from './utils/serviceWorker';
import { usePWAStore } from './store/pwaStore';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
serviceWorker.register({
  onSuccess: (registration) => {
    console.log('PWA: Content cached for offline use');
  },
  onUpdate: (registration) => {
    console.log('PWA: New version available');
    usePWAStore.getState().setUpdateAvailable(true, registration);
  },
  onOffline: () => {
    usePWAStore.getState().setIsOffline(true);
  },
  onOnline: () => {
    usePWAStore.getState().setIsOffline(false);
  },
});
